// Helpers
import { getOutlinedPositionIcon } from "@/Common/helpers/Positions/icons";

// Layouts
import PageLayer from "@/Layouts/views/PageLayer";
import FinanceManagerWashoutLayer from "@/Washouts/views/Layers/Finance/Managers/FinanceManagerWashoutLayer";

const POSITION = "Finance Manager";

export default function FinanceManagerWashout() {
	const Icon = getOutlinedPositionIcon({ position: POSITION });
	return (
		<PageLayer title={"F&I Managers Washouts"} icon={Icon}>
			<FinanceManagerWashoutLayer />
		</PageLayer>
	);
}
